import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'
import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#12579b",
        secondary: "#FFFFFF",
        accent: "#575756",
        error: colors.red.accent3,
      },
      dark: {
        primary: "#12579b",
      },
    },
  },
  icons: {
    iconfont: 'fa',
  },
});
